import * as types from "../../ActionType";

const initState = {
    vcards: [],
    loadingVcards: true
}

const VcardReducer = (state = initState, action) => {
    switch (action.type) {
        case types.GET_VCARDS:
            return { ...state, vcards: action.payload, loadingVcards: false }
        default:
            return state;
    }
};

export default VcardReducer;

